// src/pages/Landing.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const FEATURE_SLIDES = [
  {
    title: 'Discover Recipes',
    description:
      'Browse hundreds of recipes—filter by ingredient, cuisine, or dietary need—and save your favorites.',
    image: '/images/hero-explore.png',
  },
  {
    title: 'Weekly Planner',
    description:
      'Drag & drop meals into your calendar and never wonder what’s for dinner.',
    image: '/images/hero-plan.png',
  },
  {
    title: 'Smart Shopping List',
    description:
      'One-click compile of everything you need—no more scribbles on paper.',
    image: '/images/hero-shop.png',
  },
  {
    title: 'Create & Share',
    description:
      'Add your own recipes and share them with friends and the PanPals community.',
    image: '/images/hero-create.png',
  },
];

export default function LandingPage() {
  return (
    <div className="flex flex-col">
      {/* White overlay */}
      <div className="sticky absolute top-0 left-0 w-full bg-white p-4 z-10 flex items-center justify-between z-20">
        {/* Logo Name on the Left */}
        <img
          src="/images/hero-logo-name.png"
          alt="PanPals Logo Name"
          className="w-24 h-auto" // Adjust size for logo name
        />

        {/* Logo Image in the Center */}
        <div className="absolute left-1/2 transform -translate-x-1/2">
          <img
            src="/images/hero-logo-image.png"
            alt="PanPals Logo Image"
            className="w-20 h-auto"
          />
        </div>

        {/* Buttons on the Right */}
        <div className="ml-auto flex space-x-4">
          <Link
            to="/auth"
            className="px-4 py-2 bg-black text-white font-semibold rounded-full hover:opacity-90 transition"
          >
            To App
          </Link>
        </div>
      </div>
      {/* HERO */}
      <div className="relative h-screen w-full">
        <img
          src="/images/hero-headline.png"
          alt="Browse recipes"
          className="object-cover w-full h-full"
        />

        {/* Background Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>

        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center px-4 text-center">
          <h1 className="text-white text-4xl md:text-5xl font-bold leading-tight">
            Cook smarter — <br />
            Explore recipes
            <br />
            Plan meals
            <br />
            Shop easier
          </h1>
          <Link
            to="/auth"
            className="mt-6 inline-block px-6 py-3 bg-white text-black font-semibold rounded-full hover:opacity-90 transition"
          >
            Login / Sign up
          </Link>
        </div>
      </div>

      {/* FEATURES CAROUSEL */}
      <section className="py-16 bg-gray-50">
        <h2 className="text-3xl font-semibold text-center mb-2">
          Everything you need
        </h2>

        <Carousel
          showArrows
          showStatus={false}
          showThumbs={false}
          infiniteLoop
          centerMode
          centerSlidePercentage={80}
          swipeable
          className="max-w-4xl mx-auto"
        >
          {FEATURE_SLIDES.map(({ title, description, image }) => (
            <div key={title} className="flex flex-col items-center px-4">
              <img
                src={image}
                alt={title}
                className="w-full max-w-md h-64 object-cover rounded-lg shadow-lg"
              />
              <h3 className="mt-6 text-2xl font-medium">{title}</h3>
              <p className="mt-2 text-gray-600 text-center max-w-sm">
                {description}
              </p>
            </div>
          ))}
        </Carousel>
      </section>

      {/* FOOTER */}
      <footer className="bg-white border-t py-6">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-600">
            © {new Date().getFullYear()} PanPals. All rights reserved.
          </p>
          <div className="space-x-4 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-600 hover:text-gray-800">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-600 hover:text-gray-800">
              Terms of Service
            </Link>
            <Link to="/imprint" className="text-gray-600 hover:text-gray-800">
              Imprint
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
